export const environment = {
  production: false,
  baseurl: 'https://conversion-dev.scania.com/ConversionAPI/api/v1/',
  OASurl: 'https:///oasprodfe.scania.com',
  conversionWebApiUrl: 'https://api.conversion-dev.devtest.aws.scania.com/conversionwebapi',
  entraIssuer: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac/v2.0',
  entraClientId: '8101b157-5257-4ceb-b502-09ae2c2c0d42',
  scope: '9f115068-7f10-4695-b34c-b5ee966f51e2',
  oauth_redirectsignin: 'https://configurator.conversion-dev.devtest.aws.scania.com/signin',
  oauth_redirectsignout: 'https://configurator.conversion-dev.devtest.aws.scania.com/signout',
  usersv2Url: 'https://api.conversion-dev.devtest.aws.scania.com/users-v2',
  rebuildUrl: "https://api.conversion-dev.devtest.aws.scania.com/rebuildservice",
  navigationLinks: [
    { label: 'OAS', url: 'https://l1094t.sss.se.scania.com/' },
    { label: 'Workshop', url: 'https://workshop.conversion-dev.devtest.aws.scania.com/' },
    { label: 'GTS', url: 'https://gts.conversion-dev.devtest.aws.scania.com/' },
    { label: 'LTS', url: 'https://loth.conversion-dev.devtest.aws.scania.com/' },
  ],
};
